module.exports = __webpack_public_path__ + "65dd02baa669953b87671798e0a0ec88.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/head.png
// module id = 1141
// module chunks = 0